/* KHIS submissions and settings (docs/plans/phase3-khis-and-quality.md §4). Tokens only. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  min-width: 0;
}

.prose {
  max-width: 75ch;
  margin: 0;
}

.meta {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

.uid {
  font-family: var(--font-id);
}

.numeric {
  font-variant-numeric: tabular-nums;
}

.form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-4);
}

.facts {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: var(--space-2) var(--space-5);
  margin: 0;
}

.facts dt {
  color: var(--graphite);
}

.facts dd {
  margin: 0;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.rowFields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(11rem, 1fr));
  gap: var(--space-3);
  padding: var(--space-4) 0;
  border-bottom: 1px solid var(--rule);
}

.rowFields:last-child {
  border-bottom: none;
}

.rowHeading {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  font: var(--t-body-strong);
}
